import React from "react";
import { Helmet } from "react-helmet-async";
import "./WhyUs.css";

const WhyUs = () => {
  const features = [
    {
      title: "24/7 Availability",
      icon: "🕒",
      desc: "Day or night, our self-drive fleet in Indore is ready. We never sleep so you can start your journey whenever you need.",
    },
    {
      title: "Expert Chauffeurs",
      icon: "👨‍✈️",
      desc: "Professional drivers trained in safety, punctuality, and local MP routes for a stress-free travel experience.",
    },
    {
      title: "Premium Fleet",
      icon: "✨",
      desc: "From budget hatchbacks to luxury SUVs like Thar and Fortuner, every car is sanitized and showroom-maintained.",
    },
    {
      title: "Transparent Billing",
      icon: "💰",
      desc: "Honest pricing with no hidden costs or surprise surcharges. What we quote is exactly what you pay.",
    },
    {
      title: "Customized Tours",
      icon: "🗺️",
      desc: "Tailor-made spiritual Yatras and weekend getaways from Indore designed to match your specific pace and preference.",
    },
    {
      title: "Real-time Support",
      icon: "📞",
      desc: "Our dedicated helpdesk stays connected with you throughout your journey for total peace of mind.",
    },
  ];

  // Service Schema to tell Google about your specific business strengths
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Car Rental Service",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Shree Ram Car Rental"
    },
    "areaServed": {
      "@type": "City",
      "name": "Indore"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Rental Features",
      "itemListElement": features.map((f, i) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": f.title,
          "description": f.desc
        }
      }))
    }
  };

  return (
    <section className="whyus-section" aria-labelledby="why-us-title">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
      </Helmet>

      <div className="whyus-container">
        <header className="whyus-header">
          <span className="whyus-badge">THE BEST CHOICE IN INDORE</span>
          <h2 id="why-us-title">Why Travel With <span>Shree Ram Car Rental?</span></h2>
          <p className="whyus-intro">
            With <strong>5+ years of excellence</strong> in Central India, we 
            combine modern technology with traditional hospitality to provide 
            the most reliable <strong>self-drive car rental in Indore</strong>.
          </p>
        </header>

        <div className="whyus-grid">
          {features.map((item, index) => (
            <article key={index} className="why-card">
              <div className="card-glow" aria-hidden="true"></div>
              <div className="icon-box" role="img" aria-label={item.title}>
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <div className="card-border-bottom" aria-hidden="true"></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;